export enum PERMISSIONS {
  ACTIVATIONS_READ = 'activations.read',
  ADMIN_READ = 'admin.read',
  ADMIN_UPDATE = 'admin.update',
  ALL = 'all', // User has "all" key in their permissions array
  ANNOUNCEMENT_CREATE = 'announcements.create',
  ANNOUNCEMENT_DELETE = 'announcements.delete',
  ANNOUNCEMENT_PUBLISH = 'announcements.publish',
  ANNOUNCEMENT_READ = 'announcements.read',
  ANNOUNCEMENT_UPDATE = 'announcements.update',
  ASSET_CREATE = 'assets.create',
  ASSET_DELETE = 'assets.delete',
  ASSET_READ = 'assets.read',
  ASSET_UPDATE = 'assets.update',
  CASES_READ = 'cases.read',
  CASES_CREATE = 'cases.create',
  CASES_UPDATE = 'cases.update',
  CASES_DELETE = 'cases.delete',
  DEVICES_CREATE = 'devices.create',
  DEVICES_DELETE = 'devices.delete',
  DEVICES_DECOMMISSION = 'devices.decommission',
  DEVICES_READ = 'devices.read',
  DEVICES_UPDATE = 'devices.update',
  DOWNLOADS_READ = 'downloads.read',
  EDR_READ = 'edr.read',
  EXEMPT = 'exempt',
  INTERNAL = 'internal',
  LOGS_READ = 'logs.read',
  MDR_READ = 'mdr.read',
  NOT_ALL = 'not_all', // User does not have "all" key in their permissions array
  NOT_INTERNAL = 'not_internal',
  ORGANIZATIONS_CREATE = 'organizations.create',
  ORGANIZATIONS_DELETE = 'organizations.delete',
  ORGANIZATIONS_READ = 'organizations.read',
  ORGANIZATIONS_UPDATE = 'organizations.update',
  PCAPS_CREATE = 'pcaps.create',
  PCAPS_DELETE = 'pcaps.delete',
  PCAPS_READ = 'pcaps.read',
  REPORT_CREATE = 'reports.create',
  REPORT_DELETE = 'reports.delete',
  REPORT_READ = 'reports.read',
  REPORT_UPDATE = 'reports.update',
  SENSOR_RULES_CREATE = 'sensor_rules.create',
  SENSOR_RULES_DELETE = 'sensor_rules.delete',
  SENSOR_RULES_READ = 'sensor_rules.read',
  SENSOR_RULES_UPDATE = 'sensor_rules.update',
  SOURCES_CREATE = 'sources.create',
  SOURCES_DELETE = 'sources.delete',
  SOURCES_READ = 'sources.read',
  SOURCES_UPDATE = 'sources.update',
  TICKETS_COMPLETE = 'tickets.complete',
  TICKETS_CREATE = 'tickets.create',
  TICKETS_DELETE = 'tickets.delete',
  TICKETS_PUBLISH = 'tickets.publish',
  TICKETS_READ = 'tickets.read',
  TICKETS_REVIEW = 'tickets.review',
  TICKETS_SILENT = 'tickets.silent',
  TICKETS_UPDATE = 'tickets.update',
  USERS_CREATE = 'users.create',
  USERS_DELETE = 'users.delete',
  USERS_NOTIFICATIONS = 'users.notifications',
  USERS_READ = 'users.read',
  USERS_UPDATE = 'users.update',
  VMP_READ = 'vmp.read'
}

export default PERMISSIONS;
